import { fetcherSSR } from '_/services/fetcher.ssr'
import { relationshipQl } from '_/services/queryBuilder'
import type { Response } from './types'

export const query = /* GraphQL */ `
  query DestinationGuidesQl($slug: String) {
    destinations(filters: { slug: {eq: $slug} }, pagination: {pageSize: 4}) {
      data {
        id
        attributes {
          featured_guides {
            data {
							attributes {
								createdAt
								description
								excerpt
								publishedAt
								friendly_slug
								title
								updatedAt
								${relationshipQl('themes')}
								${relationshipQl('destinations')}
							}
								id
            }
          }
        }
      }
    }
  }
`

type Args = {
	slug: string
}

export const fetchFeaturedGuides = async ({ slug }: Args) => {
	try {
		const response = await fetcherSSR<Response, { query: string; variables: { [key: string]: string | number } }>({
			method: 'POST',
			endpoint: '/graphql',
			body: {
				query,
				variables: {
					slug,
				},
			},
			withAuthorization: false,
		})

		if (response?.errors?.length) {
			throw response.errors
		}

		const guidesData = response?.data?.destinations?.data[0].attributes.featured_guides.data?.map(guide => ({
			...guide,
			attributes: {
				...guide.attributes,
				slug: guide.attributes.friendly_slug,
			},
		}))

		return {
			...(response.data.destinations.data[0].attributes.featured_guides.data ?? {}),
			data: guidesData,
			error: null,
		}
	} catch (error) {
		return {
			error: error,
			data: null,
			meta: null,
		}
	}
}
